import React, { Component } from 'react';
import UserProfile from './UserProfile';
import Input from './UI/Input/Input';
import Utility from './Utility';
import "./Transaction.css";
import axios from 'axios';


export class Transaction extends Component {
    displayName = Transaction.name

    constructor(props) {
        super(props);
        this.state = {
            forecasts: [], loading: false,
            objform: {
                date1: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'Da:'
                    },
                    value: this.todayDate(),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                date2: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'A:'
                    },
                    value: this.todayDate(),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                }
            }
        }
        //this.refresh();
    };
    todayDate() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }

        return yyyy + '-' + mm + '-' + dd;
    }
    lastMoDate() {
        var today = new Date();
        var lastMo = new Date(today.setMonth(today.getMonth() - 1));
        var dd = lastMo.getDate();
        var mm = lastMo.getMonth() + 1;
        var yyyy = lastMo.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
    }
    refresh() {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Date1: this.state.objform.date1.value,
            Date2: this.state.objform.date2.value
        })
        axios.post('api/Transaction/List', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({ forecasts: respose.data, loading: false });
            })
            .catch(data => {
            });
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.objform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ objform: updatedForm, formIsValid: formIsValid }, () => {
            //this.refresh();
        });
    }

    ricerca = (event) => {
        this.refresh();
    }

    static renderTable(forecasts) {
        return (
            <table className='table' >
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Importo</th>
                        <th>Id Transazione</th>
                        <th>Tipo</th>
                    </tr>
                </thead>
                <tbody>
                    {forecasts
                        .map(forecast =>
                            <tr key={forecast.id}>
                                <td>{forecast.dataOperazione}</td>
                                <td>{forecast.segnoTransazione} {(Math.round(forecast.importoTotaleTransazione * 100) / 100).toFixed(2)} {forecast.divisa}</td>
                                <td>{forecast.idOperazione}</td>
                                <td>Pagamento</td>
                                {(forecast.idTransazione === -'P') && <td>Pagamento</td>}
                                {(forecast.idTransazione === -'R') && <td>Ricarica</td>}
                                {(forecast.idTransazione === -'A') && <td>Annullo</td>}
                                {(forecast.idTransazione === -'PB') && <td>Pagamento da Borsellino</td>}
                            </tr>
                        )}
                </tbody>
            </table>
        );
    }
    render() {
        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formInser = (
            <div className="row">
                {formElementsArray.map(formElement => (
                    <div className="col-sm-6" key={'div' + formElement.id}>
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            textdisabled={false} />
                    </div>
                ))}
                <div className="col-sm-10">
                    <button onClick={(event) => this.ricerca(event)} type="button" className="btn btn-info">RICERCA</button>
                </div>
            </div>
        );
        let contents = this.state.loading
            ? <p className="col-sm-10"><em>Loading...</em></p>
            : Transaction.renderTable(this.state.forecasts);

        return (
            <div>
                <h1>Transazioni</h1>
                {formInser}
                {contents}
            </div>
        );
    }
}
